/**
 * 每日宣传
 */
import { Toast } from 'antd-mobile';
import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';

export default {
  namespace: 'knowLedgeShareSource',
  state: {
    tabs: [], // 宣传tab菜单
    userInfo: {}, // 用户信息
  },
  reducers: {
    setTabs(state, action) {
      return {
        ...state,
        tabs: action.payload,
      };
    },
    setUserInfo(state, action) {
      return {
        ...state,
        userInfo: action.payload,
      };
    },
    resetState() {
      return {
        tabs: [],
        userInfo: {},
      };
    },
  },
  effects: {
    // 获取宣传tab菜单数据
    *getTabsList(action, { put }) {
      Toast.loading('加载中...', 0);
      const res = yield fetch.post(API.KNOWLEDGE_GET_LABEL, {
        parentId: action.payload.parentId,
      });
      Toast.hide();
      if (!res.errorType) {
        let tabsArr = [];
        res.data &&
          res.data.forEach(item => {
            tabsArr.push({
              title: item.name,
              id: item.id,
            });
          });
        yield put({
          type: 'setTabs',
          payload: tabsArr,
        });
      } else {
        Toast.fail(res.message);
      }
    },
    *getUserInfo(action, { put }) {
      const res = yield fetch.post(API.CARD_FIND);
      yield put({
        type: 'setUserInfo',
        payload: res.data || {},
      });
    },
  },
};
